<template>
  <div class="login-container">
    <div class="login-box">
      <!-- 左侧插图区域 -->
      <div class="login-illustration">
        <div class="logo">
          <img src="../assets/logo.png" alt="博亿购" />
        </div>
      </div>

      <!-- 右侧登录表单区域 -->
      <div class="login-form">
        <h2 class="login-title">欢迎来到博亿购!</h2>
        <!-- 登录方式切换 -->
        <el-tabs v-model="activeTab" class="login-tabs">
          <el-tab-pane label="密码登录" name="password">
            <el-form :model="loginForm" ref="loginForm" class="form" :rules="loginRules">
              <el-form-item prop="phone">
                <el-input v-model="loginForm.phone" placeholder="请输入手机号/账号" size="large" prefix-icon="el-icon-user"
                  maxlength="11"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="loginForm.password" :type="passwordType" placeholder="密码" size="large"
                  prefix-icon="el-icon-lock" maxlength="12"></el-input>
                <img src="~@/assets/images/60.png" alt="隐藏密码" v-if="passwordType == 'password'" class="show-pwd"
                  @click="showPwd" />
                <img src="~@/assets/images/61.png" alt="显示密码" v-else class="show-pwd" @click="showPwd" />
              </el-form-item>
              <div class="form-actions">
                <el-link type="primary" class="forgot-link" :underline="false"><span style="color:#999999">还没有账号？</span>
                  <router-link to="/register" style="color:#286CED">立即注册</router-link></el-link>
                <el-link type="primary" class="forgot-link" :underline="false"
                  @click.prevent="handleForgetPassword">忘记密码？</el-link>
              </div>
              <el-button type="primary" @click="handleLogin" size="large" class="login-button" block>
                登录
              </el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="验证码登录" name="verify">
            <el-form :model="verifyForm" ref="verifyForm" class="form" :rules="verifyRules">
              <el-form-item prop="phone">
                <el-input v-model="verifyForm.phone" placeholder="请输入手机号" size="large" prefix-icon="el-icon-mobile"
                  maxlength="11"></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <el-input v-model="verifyForm.verifyCode" placeholder="验证码" size="large" prefix-icon="el-icon-message"
                  maxlength="4" type="text">
                  <template slot="append">
                    <get-verify-code :phone="verifyForm.phone" :code-type="'3'"></get-verify-code>
                  </template>
                </el-input>
              </el-form-item>
              <div class="form-actions">
                <el-link type="primary" class="forgot-link" :underline="false"><span style="color:#999999">还没有账号？</span>
                  <router-link to="/register" style="color:#286CED">立即注册</router-link></el-link>
                <el-link type="primary" class="forgot-link" :underline="false"
                  @click.prevent="handleForgetPassword">忘记密码？</el-link>
              </div>
              <el-button type="primary" @click="handleVerifyLogin" size="large" class="login-button" block>
                登录
              </el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>

        <div class="agreement">
          <el-checkbox v-model="is_agreement" size="small">
            已阅读并同意 <el-link type="primary" :underline="false" size="small">
              <a href="https://www.bykjy.com/automatic/m13759.Agreement/content?id=1" target="_blank"
                rel="noopener noreferrer">《用户注册协议》</a>
            </el-link>与
            <el-link type="primary" :underline="false" size="small">
              <a href="https://www.bykjy.com/automatic/m13759.Agreement/content?id=2" target="_blank"
                rel="noopener noreferrer">《隐私政策》</a>
            </el-link>
          </el-checkbox>
        </div>

      </div>
    </div>

    <!-- 版权信息 -->
    <div class="copyright">
      Copyright©2023 盐城搏亿能源科技发展有限公司 备案号：
      <div v-html="systemParams.app_icp"></div>
    </div>
  </div>
</template>

<script>
import { phoneRules, passwordRules } from '../utils/validate'
import GetVerifyCode from '../components/GetVerifyCode.vue'
import { connectGoEasy } from '../utils/goeasy'
export default {
  name: 'Login',
  components: {
    GetVerifyCode
  },
  data() {
    return {
      rememberMe: false,
      systemParams: {},
      passwordType: 'password',
      activeTab: 'password',
      countdown: 0,
      timer: null,
      loginForm: {
        phone: '',
        password: '',
      },
      verifyForm: {
        phone: '',
        verifyCode: '',
      },
      is_agreement: false,
      // 密码登录表单验证规则
      loginRules: {
        phone: phoneRules(),
        password: passwordRules(),
      },
      // 验证码登录表单验证规则
      verifyRules: {
        phone: phoneRules(),
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.getSystemParams();
  },
  methods: {
    getSystemParams() {
      this.$api.getSystemParams({}).then(res => {
        this.systemParams = res;
      }).catch(err => {
        this.$message.error(err);
      })
    },
    handleForgetPassword() {
      this.$router.push('/forgetPassword');
    },
    showPwd() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (!this.is_agreement) return this.$message.warning('请同意隐私协议与服务条款');
          this.$api.passwordLogin({
            account: this.loginForm.phone,
            account_type: 'mobile',
            password: this.loginForm.password,
            user_source: 'web',
          }).then(res => {
            this.$message.success('登录成功');
            // 同时设置token和用户信息
            this.$store.dispatch('login', {
              token: res.userinfo.user_token,
              userInfo: res.userinfo
            });
            // 登录成功后建立 GoEasy IM 连接
            connectGoEasy(res.userinfo);
            // 登录成功后获取当前城市
            this.getNowCity();
            // 登录成功后获取认证状态
            this.getCertifiedFun();
            // 登录成功后跳转回原页面或首页
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);
          }).catch(err => {
            this.$message.warning(err);
          });
        }
      })
    },

    // 获取当前城市位置
    getNowCity() {
      this.$api.getNowCity().then(res => {
        let cityCode = res.code
        this.$store.commit('SET_CITY', {
          cityCode
        })
      }).catch(err => {
        this.$message.error(err);
      })
    },

    // 获取认证状态
    getCertifiedFun() {
      this.$api.userInfo().then(res => {
        this.$store.commit('SET_CERTIFIED', res.certified)
      }).catch(err => {
        this.$message.error(err);
      })
    },

    handleVerifyLogin() {
      console.log(1111);
      console.log("this.verifyForm:", this.$refs.verifyForm);
      this.$refs.verifyForm.validate((valid) => {
        if (valid) {
          if (!this.is_agreement) return this.$message.warning('请同意隐私协议与服务条款');
          this.$api.codeLogin({
            mobile: this.verifyForm.phone,
            type: '3',
            code: this.verifyForm.verifyCode,
            user_source: 'web',
          }).then(res => {
            this.$message.success('登录成功');
            // 同时设置token和用户信息
            this.$store.dispatch('login', {
              token: res.userinfo.user_token,
              userInfo: res.userinfo
            });
            // 登录成功后建立 GoEasy IM 连接
            connectGoEasy(res.userinfo);
            // 登录成功后获取当前城市
            this.getNowCity();
            // 登录成功后获取认证状态
            this.getCertifiedFun();
            // 登录成功后跳转回原页面或首页
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);
          }).catch(err => {
            this.$message.warning(err);
          });
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },


  },
}
</script>

<style scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  /* 使用渐变背景 */
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  /* 也可以使用背景图片 */
  background-image: url('../assets/images/4.png');
  /* background-size: cover; */
  /* background-position: center; */
  /* background-repeat: no-repeat; */
}

.login-box {
  display: flex;
  width: 1082px;
  height: 608px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* 左侧插图区域 */
.login-illustration {
  position: relative;
  width: 596px;
  height: 608px;
  background-image: url('../assets/images/3.png');
  background-size: cover;
  /* background-position: center; */
}

.logo {
  position: absolute;
  top: 28px;
  left: 47px;
}

.logo img {
  /* width: 156px; */
  height: 80px;
}

/* 右侧登录表单区域 */
.login-form {
  flex: 1;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
}

.login-title {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 30px;
}

/* 登录方式切换 */
.login-tabs {
  margin-bottom: 30px;

  /deep/ .el-tabs__header {
    margin: 0;
    border-bottom: none;
  }

  /deep/ .el-tabs__nav-wrap {
    border-bottom: none;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
    height: 0;
  }

  /deep/ .el-tabs__nav {
    border-bottom: none;
  }

  /deep/ .el-tabs__item {
    padding: 10px 20px;
    font-size: 16px;
    color: #666;
    border: none !important;
    background: transparent;
    position: relative;
    margin-right: 30px;
  }

  /deep/ .el-tabs__item::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #286CED;
    transition: width 0.3s ease;
  }

  /deep/ .el-tabs__item.is-active {
    color: #286CED;
  }

  /deep/ .el-tabs__item.is-active::before {
    width: 100%;
  }

  /deep/ .el-tabs__content {
    padding-top: 20px;
  }
}

/* 表单样式 */
.form {
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.remember-checkbox {
  color: #666;
  font-size: 14px;
}

.forgot-link {
  font-size: 14px;
  color: #286CED;
}

.login-button {
  height: 40px;
  font-size: 16px;
  font-weight: bold;
  border-color: #286CED;
  margin-bottom: 20px;
  width: 390px;
  height: 48px;
  background: #286CED;
  border-radius: 8px 8px 8px 8px;
}

.login-button:hover {
  background-color: #2158c7;
  border-color: #2158c7;
}

/* 协议部分 */
.agreement {
  font-size: 12px;
  color: #666;
  margin-top: 10px;
}

.agreement .el-checkbox__label {
  color: #666;
  font-size: 12px;
}

.el-link.el-link--primary {
  color: #286CED;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #286CED;
}


::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #286CED;
  border-color: #286CED;
}

/* 自定义Element UI标签页样式 */
::v-deep .el-tabs__header .is-top::after {
  background-color: transparent !important;
}

::v-deep .el-tabs__item.is-active {
  color: #286CED;
}

::v-deep .el-tabs__active-bar {
  background-color: #286CED;
}

.copyright {
  font-weight: 400;
  font-size: 14px;
  color: #10357B;
  margin-top: 168px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.show-pwd {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  user-select: none;
  width: 24px;
  height: 24PX;
}
</style>